import moment from 'moment';

const TOGGLE_CHECKBOX = 'tuko-kalenteri/yearView/TOGGLE_CHECKBOX';
const SET_YEARVIEWDATE = 'tuko-kalenteri/yearView/SET_YEARVIEWDATE';

export default function yearview(state = { isChecked: false, yearViewDate: moment() }, action) {
  switch (action.type) {
    case TOGGLE_CHECKBOX:
      return Object.assign({}, state, { isChecked: action.isChecked });
    case SET_YEARVIEWDATE:
      return Object.assign({}, state, { yearViewDate: action.yearViewDate });
    default:
      return state;
  }
}

export function toggleCheckbox(isChecked) {
  return { type: TOGGLE_CHECKBOX, isChecked };
}

export function setYearViewDate(yearViewDate) {
  return { type: SET_YEARVIEWDATE, yearViewDate };
}



// WEBPACK FOOTER //
// ./src/reducers/yearView.js